import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import tms from './modules/tms'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    tms
  },
  strict: false,
  plugins: []
})
